import React, { Component } from 'react'
import { back, push } from '../actions/nav-actions';
import { connect } from 'react-redux';

class Card extends Component {
    constructor(props) {
        super(props)
        this.state = {
            open: props.open
        }
    }
    render() {

        let CardComponent = this.props.component || React.Fragment;
        let classaname = "collapse"

        if (this.state.open) {
            classaname += " show"
        }

        return (
            <div id={this.props.keyId} className="card" style={{ ...this.props.style }}>
                <div className="card-header">
                    <h5>
                        <a onClick={e => {
                            e.preventDefault()
                            //this.props.match.url
                            //window.
                            if (this.props.push) {
                                this.props.push(`${this.props.match.url}/#${this.props.keyId}`)
                            }
                            this.setState({ open: !this.state.open })
                        }} href={`#accordion-collapse-${this.props.keyId}`}>
                            {this.props.title}
                        </a>
                    </h5>
                </div>
                <div className={classaname}>
                    <div className="card-body">
                        {this.props.component ? <CardComponent {...this.props} /> : null}
                        {this.props.children}
                    </div>
                </div>
            </div>
        )
    }
}

class Accordion extends Component {
    render() {
        return (
            <div id="msar-accrdn">
                {this.props.children}
            </div>
        )
    }
}


const mapStateToProps = state => ({ ...state.localStorage, user: state.authReducer.user });

const mapDispatchToProps = dispatch => ({
    back() {
        dispatch(back())
    },
    push(routeName) {
        dispatch(push(routeName))
    }
})

const MyCard = connect(mapStateToProps, mapDispatchToProps)(Card)

Accordion.Card = MyCard;


export default Accordion;


// WEBPACK FOOTER //
// ./src/components/Accordion.js